import { Image } from 'antd'

const Img = (props) => {
  return <Image alt="img" preview={false} {...props} />
}
export default Img
